/* <-------------------V_BEL_PDP_03 | Perfekte-Passform-Garantie Framing-----------------> */
/* Sends the card-view event (name from the section settings) once per page view in Var A.
   The card is display:none until Var A's body class lands, so it can only intersect then. */
(function () {
  function setupGuaranteeCardObserver() {
    var card = document.querySelector('.c-ppg-guarantee-card');
    if (!card || !card.dataset.cViewEvent || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || !document.body.classList.contains('c-perfektePassformVarA')) return;
          observer.disconnect();
          window.igEvents = window.igEvents || [];
          window.igEvents.push({ event: card.dataset.cViewEvent });
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(card);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupGuaranteeCardObserver);
  } else {
    setupGuaranteeCardObserver();
  }
})();
